import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withFormik } from 'formik';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { bindPromiseCreators, promisifyRoutine } from 'redux-saga-routines';

import { ResetPasswordForm } from './resetPasswordForm.component';
import { ResetPasswordSchema, defaultValues } from './resetPasswordForm.constants';
import { resetPasswordRoutine } from '../../../modules/auth/auth.redux';
import { AuthActions } from '../../../modules/auth';

export const resetPasswordRoutinePromiseCreator = promisifyRoutine(resetPasswordRoutine);

const mapStateToProps = createStructuredSelector({});

export const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    {
      hideModal: AuthActions.hideModal,
    },
    dispatch
  ),
  ...bindPromiseCreators({ resetPasswordRoutinePromiseCreator }, dispatch),
});

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter,
  withFormik({
    mapPropsToValues: () => defaultValues,
    handleSubmit: async (data, { props, ...formik }) => {
      try {
        formik.setSubmitting(true);

        await props.resetPasswordRoutinePromiseCreator(data);
      } catch ({ errors }) {
        formik.setErrors(errors);
      } finally {
        formik.setSubmitting(false);
      }
    },
    validationSchema: () => ResetPasswordSchema,
  })
)(ResetPasswordForm);
